(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  function initAnnouncement(bar) {
    if (bar.dataset.annInit === "true") return;
    bar.dataset.annInit = "true";

    var items = Array.prototype.slice.call(bar.querySelectorAll("[data-ann-item]"));
    var prev = bar.querySelector("[data-ann-prev]");
    var next = bar.querySelector("[data-ann-next]");
    var autoplay = bar.getAttribute("data-autoplay") === "true";
    var speed = parseFloat(bar.getAttribute("data-speed")) || 5;
    var i = 0;
    var timer = null;

    if (items.length < 2) {
      if (prev) prev.style.display = "none";
      if (next) next.style.display = "none";
      return;
    }

    function show(n) {
      items[i].classList.remove("is-active");
      i = (n + items.length) % items.length;
      items[i].classList.add("is-active");
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (autoplay) {
        timer = setInterval(function () { show(i + 1); }, speed * 1000);
      }
    }

    if (prev) prev.addEventListener("click", function () { show(i - 1); start(); });
    if (next) next.addEventListener("click", function () { show(i + 1); start(); });
    bar.addEventListener("mouseenter", stop);
    bar.addEventListener("mouseleave", start);

    start();
  }

  function bootAnnouncement(scope) {
    (scope || document).querySelectorAll("[data-ann]").forEach(initAnnouncement);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { bootAnnouncement(document); });
  } else {
    bootAnnouncement(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    bootAnnouncement(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  function initCartPage(root) {
    if (root.dataset.cartpInit === "true") return;
    root.dataset.cartpInit = "true";
    var form = root.querySelector("[data-cartp-form]");
    if (!form) return;

    root.querySelectorAll("[data-citem]").forEach(function (line) {
      var input = line.querySelector("[data-cartp-qty]");
      var minus = line.querySelector("[data-cartp-minus]");
      var plus = line.querySelector("[data-cartp-plus]");
      function val() { var n = parseInt(input.value, 10); return isNaN(n) ? 0 : n; }
      if (minus) minus.addEventListener("click", function () { input.value = Math.max(0, val() - 1); form.submit(); });
      if (plus) plus.addEventListener("click", function () { input.value = val() + 1; form.submit(); });
    });
  }

  function bootCartPage(scope) {
    (scope || document).querySelectorAll("[data-cartp]").forEach(initCartPage);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { bootCartPage(document); });
  } else { bootCartPage(document); }
  document.addEventListener("shopify:section:load", function (e) { bootCartPage(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-index"] && !Shopify.designMode) return;
  try {
    
  function initCatIndex(el) {
    if (el.dataset.catInit === "true") return;
    el.dataset.catInit = "true";
    var rows = Array.prototype.slice.call(el.querySelectorAll("[data-cat-row]"));
    if (rows.length === 0) return;
    var preview = el.querySelector("[data-cat-preview]");
    var label = el.querySelector("[data-cat-label]");

    function setActive(row) {
      rows.forEach(function (r) {
        r.classList.toggle("is-active", r === row);
      });
      if (preview) {
        var img = row.getAttribute("data-image");
        preview.style.backgroundImage = img ? "url(" + img + ")" : "";
      }
      if (label) {
        label.textContent = row.getAttribute("data-name") || "";
      }
    }

    rows.forEach(function (r) {
      r.addEventListener("mouseenter", function () {
        setActive(r);
      });
    });
    setActive(rows[0]);
  }

  function bootCatIndex() {
    document.querySelectorAll("[data-cat-index]").forEach(initCatIndex);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootCatIndex);
  } else {
    bootCatIndex();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var el = event.target.querySelector("[data-cat-index]");
    if (el) initCatIndex(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  function initCollectionSort(scope) {
    (scope || document).querySelectorAll("[data-sort-select]").forEach(function (select) {
      if (select.dataset.sortInit === "true") return;
      select.dataset.sortInit = "true";
      select.addEventListener("change", function () {
        var form = select.closest("[data-sort-form]");
        if (form) form.submit();
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initCollectionSort(document);
    });
  } else {
    initCollectionSort(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initCollectionSort(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function initHeader(header) {
    if (header.dataset.headerInit === "true") return;
    header.dataset.headerInit = "true";

    var closeSearch = function () {};

    /* ---- Mega menú (escritorio) ---- */
    var triggers = Array.prototype.slice.call(header.querySelectorAll("[data-mega-trigger]"));
    var megas = Array.prototype.slice.call(header.querySelectorAll("[data-mega]"));

    function closeMegas() {
      megas.forEach(function (m) { m.classList.remove("is-open"); m.setAttribute("aria-hidden", "true"); });
      triggers.forEach(function (t) { t.classList.remove("is-open"); });
    }
    function openMega(i) {
      closeMegas();
      closeSearch();
      var m = header.querySelector('[data-mega="' + i + '"]');
      var t = header.querySelector('[data-mega-trigger="' + i + '"]');
      if (m) { m.classList.add("is-open"); m.setAttribute("aria-hidden", "false"); }
      if (t) t.classList.add("is-open");
    }
    triggers.forEach(function (t) {
      t.addEventListener("mouseenter", function () { openMega(t.getAttribute("data-mega-trigger")); });
    });
    header.addEventListener("mouseleave", function () { closeMegas(); closeSearch(); });
    header.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeMegas(); closeSearch(); } });

    /* categorías: cambia la lista de en medio */
    megas.forEach(function (mega) {
      var cats = Array.prototype.slice.call(mega.querySelectorAll("[data-mega-cat]"));
      var lists = Array.prototype.slice.call(mega.querySelectorAll("[data-mega-items]"));
      cats.forEach(function (cat) {
        cat.addEventListener("mouseenter", function () {
          var idx = cat.getAttribute("data-mega-cat");
          cats.forEach(function (c) { c.classList.toggle("is-active", c === cat); });
          lists.forEach(function (l) { l.classList.toggle("is-active", l.getAttribute("data-mega-items") === idx); });
        });
      });
    });

    /* ---- Búsqueda desplegable ---- */
    var sToggle = header.querySelector("[data-search-toggle]");
    var sPanel = header.querySelector("[data-search-panel]");
    if (sToggle && sPanel) {
      var sInput = sPanel.querySelector("[data-search-input]");
      var sDefault = sPanel.querySelector("[data-search-default]");
      var sResults = sPanel.querySelector("[data-search-results]");
      var sCloseBtn = sPanel.querySelector("[data-search-close]");
      var suggestUrl = sPanel.getAttribute("data-suggest-url");
      var searchUrl = sPanel.getAttribute("data-search-url");
      var sOpen = false;
      var sTimer = null;

      var sEsc = function (s) {
        return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
          return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
        });
      };
      var sShowDefault = function () {
        if (sDefault) sDefault.hidden = false;
        if (sResults) { sResults.hidden = true; sResults.innerHTML = ""; }
      };
      var sShowResults = function () {
        if (sDefault) sDefault.hidden = true;
        if (sResults) sResults.hidden = false;
      };

      var openSearch = function () {
        if (sOpen) return;
        closeMegas();
        sOpen = true;
        sPanel.classList.add("is-open");
        sPanel.setAttribute("aria-hidden", "false");
        sToggle.setAttribute("aria-expanded", "true");
        setTimeout(function () { if (sInput) sInput.focus(); }, 70);
      };
      closeSearch = function () {
        if (!sOpen) return;
        sOpen = false;
        sPanel.classList.remove("is-open");
        sPanel.setAttribute("aria-hidden", "true");
        sToggle.setAttribute("aria-expanded", "false");
      };

      sToggle.addEventListener("mouseenter", function () {
        if (window.matchMedia("(min-width: 901px)").matches) openSearch();
      });
      sToggle.addEventListener("click", function (e) {
        e.preventDefault();
        if (sOpen) closeSearch(); else openSearch();
      });
      if (sCloseBtn) sCloseBtn.addEventListener("click", function () { closeSearch(); if (sToggle.focus) sToggle.focus(); });

      var renderSuggest = function (q, data) {
        var res = (data && data.resources && data.resources.results) || {};
        var products = res.products || [];
        var reads = (res.articles || []).concat(res.pages || []);
        var html = "";
        if (products.length) {
          html += '<div class="hsr__group"><p class="hsr__glbl">Productos</p><div class="hsr__plist">';
          products.forEach(function (p) {
            var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (typeof p.image === "string" ? p.image : "");
            html += '<a class="hsr__p" href="' + p.url + '"><span class="hsr__p-img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : "") + '</span><span class="hsr__p-nm">' + sEsc(p.title) + "</span></a>";
          });
          html += "</div></div>";
        }
        if (reads.length) {
          html += '<div class="hsr__group"><p class="hsr__glbl">Lectura</p><ul class="hsr__links">';
          reads.forEach(function (a) { html += '<li><a href="' + a.url + '">' + sEsc(a.title) + "</a></li>"; });
          html += "</ul></div>";
        }
        if (!products.length && !reads.length) {
          html += '<p class="hsr__none">Nada para <em>' + sEsc(q) + "</em>. Prueba con otra palabra.</p>";
        }
        html += '<a class="hsr__seeall" href="' + searchUrl + "?q=" + encodeURIComponent(q) + '">Ver todo</a>';
        if (sResults) sResults.innerHTML = html;
        sShowResults();
      };

      var fetchSuggest = function (q) {
        if (!suggestUrl) return;
        fetch(suggestUrl + ".json?q=" + encodeURIComponent(q) + "&resources[type]=product,article,page&resources[limit]=6", { headers: { Accept: "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (data) { renderSuggest(q, data); })
          .catch(function () {});
      };

      if (sInput) {
        sInput.addEventListener("input", function () {
          var q = sInput.value.trim();
          clearTimeout(sTimer);
          if (q.length < 2) { sShowDefault(); return; }
          sTimer = setTimeout(function () { fetchSuggest(q); }, 220);
        });
      }
    }

    /* ---- Carrito ---- */
    var cartBtn = header.querySelector("[data-cart-open]");
    if (cartBtn) cartBtn.addEventListener("click", function () { document.dispatchEvent(new CustomEvent("cart:open")); });

    /* ---- Drawer móvil multinivel ---- */
    var draw = header.querySelector("[data-mdraw]");
    if (!draw) return;
    var toggle = header.querySelector("[data-nav-toggle]");
    var stage = draw.querySelector("[data-mstage]");
    var backBtn = draw.querySelector("[data-mback]");
    var backLabel = draw.querySelector("[data-mback-label]");
    var stack = ["root"];

    function panel(id) { return draw.querySelector('[data-panel="' + id + '"]'); }

    function render() {
      draw.querySelectorAll(".mpanel").forEach(function (p) { p.classList.remove("is-active", "is-behind"); });
      var active = stack[stack.length - 1];
      var behind = stack.length > 1 ? stack[stack.length - 2] : null;
      var ap = panel(active); if (ap) ap.classList.add("is-active");
      if (behind) { var bp = panel(behind); if (bp) bp.classList.add("is-behind"); }
      if (stack.length > 1) {
        backBtn.hidden = false;
        var parentPanel = panel(active);
        var opener = draw.querySelector('[data-open="' + active + '"]');
        if (backLabel) backLabel.textContent = opener ? opener.getAttribute("data-title") : "";
      } else {
        backBtn.hidden = true;
      }
    }
    function openDraw() {
      draw.classList.add("is-open"); draw.setAttribute("aria-hidden", "false");
      document.documentElement.style.overflow = "hidden";
      if (toggle) toggle.setAttribute("aria-expanded", "true");
    }
    function closeDraw() {
      draw.classList.remove("is-open"); draw.setAttribute("aria-hidden", "true");
      document.documentElement.style.overflow = "";
      if (toggle) toggle.setAttribute("aria-expanded", "false");
      setTimeout(function () { stack = ["root"]; render(); }, 350);
    }

    if (toggle) toggle.addEventListener("click", openDraw);
    draw.querySelectorAll("[data-mdraw-close]").forEach(function (b) { b.addEventListener("click", closeDraw); });
    if (backBtn) backBtn.addEventListener("click", function () { if (stack.length > 1) { stack.pop(); render(); } });

    stage.querySelectorAll("[data-open]").forEach(function (row) {
      row.addEventListener("click", function () { stack.push(row.getAttribute("data-open")); render(); });
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && draw.classList.contains("is-open")) closeDraw(); });

    render();
  }

  function bootHeader(scope) { (scope || document).querySelectorAll("[data-header]").forEach(initHeader); }
  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", function () { bootHeader(document); }); } else { bootHeader(document); }
  document.addEventListener("shopify:section:load", function (e) { bootHeader(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  function initHero(hero) {
    if (hero.dataset.heroInit === "true") return;
    hero.dataset.heroInit = "true";
    var viewport = hero.querySelector(".hero__viewport");
    var slides = Array.prototype.slice.call(viewport.querySelectorAll(".hero__slide"));
    if (slides.length === 0) return;
    var dotsWrap = hero.querySelector("[data-hero-dots]");
    var autoplay = hero.getAttribute("data-autoplay") === "true";
    var speed = parseInt(hero.getAttribute("data-speed"), 10) || 6;
    var index = 0;
    var timer = null;
    var dots = [];

    if (dotsWrap) {
      slides.forEach(function (slide, k) {
        var dot = document.createElement("button");
        dot.className = "hero__dot";
        dot.type = "button";
        dot.setAttribute("aria-label", "Slide " + (k + 1));
        dot.addEventListener("click", function () {
          show(k);
          restart();
        });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    function show(n) {
      index = (n + slides.length) % slides.length;
      slides.forEach(function (slide, k) {
        slide.classList.toggle("is-active", k === index);
      });
      dots.forEach(function (dot, k) {
        dot.classList.toggle("is-active", k === index);
      });
      if (dotsWrap) {
        var dark = slides[index].getAttribute("data-dark") === "true";
        dotsWrap.classList.toggle("hero__dots--light", dark);
      }
    }

    function start() {
      if (autoplay && slides.length > 1) {
        timer = setInterval(function () {
          show(index + 1);
        }, speed * 1000);
      }
    }

    function restart() {
      clearInterval(timer);
      start();
    }

    hero.addEventListener("mouseenter", function () {
      clearInterval(timer);
    });
    hero.addEventListener("mouseleave", start);

    show(0);
    start();
  }

  function bootHeroes() {
    document.querySelectorAll("[data-hero]").forEach(initHero);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootHeroes);
  } else {
    bootHeroes();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var hero = event.target.querySelector("[data-hero]");
    if (hero) initHero(hero);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-temporada"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.pmodalReady === "1") return;
      root.dataset.pmodalReady = "1";

      var campaign = root.getAttribute("data-campaign") || "temporada";
      var frequency = root.getAttribute("data-frequency") || "every3";
      var delay = parseInt(root.getAttribute("data-delay"), 10);
      if (isNaN(delay)) delay = 4;

      var KEY = "ypita_popup_" + campaign;
      var lastFocus = null;
      var timer = null;

      // En el editor la sección se dibuja en el flujo de la página (clase
      // .pmodal--editor) para que Kevin la vea siempre. Ahí no corre nada:
      // ni retraso, ni frecuencia, ni abrir/cerrar.
      if (window.Shopify && window.Shopify.designMode) return;

      // IMPORTANTE: lo sacamos a <body>. El tema anima #main-content con
      // translateY y le queda un transform pegado; cualquier ancestro con
      // transform rompe position:fixed y el modal se posicionaría contra
      // <main> (miles de px de alto) en vez de contra la ventana, dejando la
      // tarjeta fuera de pantalla. Colgando de <body> es inmune a eso.
      if (root.parentNode !== document.body) document.body.appendChild(root);

      function store(kind) {
        try { return kind === "session" ? window.sessionStorage : window.localStorage; }
        catch (e) { return null; }
      }

      // Decide si toca mostrarlo, y de paso lleva la cuenta de visitas.
      function shouldShow() {
        if (frequency === "always") return true;

        if (frequency === "session") {
          var ss = store("session");
          if (!ss) return true;
          if (ss.getItem(KEY)) return false;
          ss.setItem(KEY, "1");
          return true;
        }

        var ls = store("local");
        if (!ls) return true;

        if (frequency === "once") {
          if (ls.getItem(KEY)) return false;
          ls.setItem(KEY, "1");
          return true;
        }

        // every3: se muestra en la visita 1, 4, 7...
        var n = parseInt(ls.getItem(KEY), 10);
        if (isNaN(n) || n < 0) n = 0;
        ls.setItem(KEY, String(n + 1));
        return n % 3 === 0;
      }

      function open() {
        root.hidden = false;
        lastFocus = document.activeElement;
        document.body.style.overflow = "hidden";
        requestAnimationFrame(function () { root.classList.add("is-in"); });
        var x = root.querySelector("[data-pmodal-close]");
        if (x) { try { x.focus({ preventScroll: true }); } catch (e) {} }
      }

      function close() {
        root.classList.remove("is-in");
        document.body.style.overflow = "";
        window.setTimeout(function () { root.hidden = true; }, 340);
        if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
      }

      root.querySelectorAll("[data-pmodal-close]").forEach(function (b) {
        b.addEventListener("click", close);
      });
      root.addEventListener("click", function (e) { if (e.target === root) close(); });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && !root.hidden) close();
      });

      // Mantiene el tabulador dentro del modal mientras está abierto.
      root.addEventListener("keydown", function (e) {
        if (e.key !== "Tab") return;
        var f = root.querySelectorAll('a[href], button:not([disabled])');
        if (!f.length) return;
        var first = f[0];
        var last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });

      if (shouldShow()) {
        timer = window.setTimeout(open, delay * 1000);
      }
    }

    function boot() {
      document.querySelectorAll("[data-pmodal]").forEach(init);
    }

    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
    else boot();
    document.addEventListener("shopify:section:load", boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-standard"] && !Shopify.designMode) return;
  try {
    
  function initPdpStd(root) {
    if (root.dataset.pdpsInit === "true") return;
    root.dataset.pdpsInit = "true";

    var dataEl = root.querySelector("[data-pdps-variants]");
    if (!dataEl) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var priceEl = root.querySelector("[data-pdps-price]");
    var addPriceEl = root.querySelector("[data-pdps-add-price]");
    var addBtn = root.querySelector("[data-pdps-add]");
    var idInput = root.querySelector("[data-pdps-id]");
    var availEl = root.querySelector("[data-pdps-avail]");
    var mainImg = root.querySelector("[data-pdps-main]");
    var groups = Array.prototype.slice.call(root.querySelectorAll("[data-pdps-optgroup]"));

    function priceHtml(v) {
      if (v.cprice) {
        return '<span class="pdps__price-now pdps__price-now--sale">' + v.price + '</span>' +
          ' <s class="pdps__price-was">' + v.cprice + "</s>" +
          (v.off ? ' <span class="pdps__price-off">\u2212' + v.off + "%</span>" : "");
      }
      return '<span class="pdps__price-now">' + v.price + "</span>";
    }

    function currentSelection() {
      return groups.map(function (g) {
        var on = g.querySelector(".pdps__opt.is-active");
        return on ? on.getAttribute("data-value") : null;
      });
    }

    function findVariant(sel) {
      if (!groups.length) return variants[0];
      return variants.filter(function (v) {
        for (var i = 0; i < sel.length; i++) {
          if (sel[i] != null && v.options[i] !== sel[i]) return false;
        }
        return true;
      })[0];
    }

    function markSoldOut(sel) {
      groups.forEach(function (g, gi) {
        g.querySelectorAll(".pdps__opt").forEach(function (opt) {
          var test = sel.slice();
          test[gi] = opt.getAttribute("data-value");
          var v = findVariant(test);
          opt.classList.toggle("is-soldout", !!(v && !v.available));
        });
      });
    }

    function apply(v) {
      if (!v) return;
      if (priceEl) priceEl.innerHTML = priceHtml(v);
      if (idInput) idInput.value = v.id;

      if (mainImg && mainImg.tagName === "IMG") {
        var matched = null;
        if (v.media_id != null) {
          matched = root.querySelector('[data-pdps-thumb][data-media-id="' + v.media_id + '"]');
        }
        if (matched) {
          root.querySelectorAll("[data-pdps-thumb]").forEach(function (x) { x.classList.remove("is-active"); });
          matched.classList.add("is-active");
          mainImg.removeAttribute("srcset");
          mainImg.src = matched.getAttribute("data-full");
        } else if (v.img) {
          mainImg.removeAttribute("srcset");
          mainImg.src = v.img.indexOf("?") > -1 ? v.img : v.img + "?width=1200";
        }
      }

      if (availEl) {
        if (!v.available) {
          availEl.hidden = false;
          availEl.textContent = "Agotado por ahora";
        } else {
          availEl.hidden = true;
        }
      }

      if (addBtn) {
        if (!v.available) {
          addBtn.textContent = "Agotado";
          addBtn.classList.add("is-out");
          addBtn.type = "button";
        } else {
          addBtn.classList.remove("is-out");
          addBtn.type = "submit";
          addBtn.innerHTML = 'Agregar · <span data-pdps-add-price>' + v.price + "</span>";
        }
      }
    }

    groups.forEach(function (g) {
      g.querySelectorAll("[data-pdps-opt]").forEach(function (opt) {
        opt.addEventListener("click", function () {
          g.querySelectorAll(".pdps__opt").forEach(function (o) { o.classList.remove("is-active"); });
          opt.classList.add("is-active");
          var sel = currentSelection();
          markSoldOut(sel);
          apply(findVariant(sel));
        });
      });
    });

    var qty = root.querySelector("[data-pdps-qty]");
    var qminus = root.querySelector("[data-pdps-qminus]");
    var qplus = root.querySelector("[data-pdps-qplus]");
    function getQty() { var n = parseInt(qty.value, 10); return isNaN(n) || n < 1 ? 1 : n; }
    if (qminus) qminus.addEventListener("click", function () { qty.value = Math.max(1, getQty() - 1); });
    if (qplus) qplus.addEventListener("click", function () { qty.value = getQty() + 1; });

    var addUrl = root.getAttribute("data-cart-add") || "/cart/add.js";
    var form = root.querySelector("form.pdps__form");
    if (form) {
      form.addEventListener("submit", function (e) {
        if (addBtn && addBtn.classList.contains("is-out")) { e.preventDefault(); return; }
        e.preventDefault();
        var id = idInput ? idInput.value : null;
        if (!id) return;
        var original = addBtn.innerHTML;
        addBtn.disabled = true;
        fetch(addUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: id, quantity: getQty() }] })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            addBtn.innerHTML = "Agregado ✓";
            document.dispatchEvent(new CustomEvent("cart:updated"));
            setTimeout(function () { addBtn.innerHTML = original; addBtn.disabled = false; }, 1600);
          })
          .catch(function () { addBtn.innerHTML = original; addBtn.disabled = false; });
      });
    }

    root.querySelectorAll("[data-pdps-thumb]").forEach(function (t) {
      t.addEventListener("click", function () {
        root.querySelectorAll("[data-pdps-thumb]").forEach(function (x) { x.classList.remove("is-active"); });
        t.classList.add("is-active");
        if (mainImg && mainImg.tagName === "IMG") {
          mainImg.removeAttribute("srcset");
          mainImg.src = t.getAttribute("data-full");
        }
      });
    });

    root.querySelectorAll("[data-pdps-acc]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var panel = btn.parentNode.querySelector("[data-pdps-acc-panel]");
        var open = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", open ? "false" : "true");
        if (panel) panel.hidden = open;
      });
    });

    apply(findVariant(currentSelection()));
    markSoldOut(currentSelection());
  }

  function bootPdpStd(scope) {
    (scope || document).querySelectorAll("[data-pdps]").forEach(initPdpStd);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { bootPdpStd(document); });
  } else { bootPdpStd(document); }
  document.addEventListener("shopify:section:load", function (e) { bootPdpStd(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  function initPdp(root) {
    if (root.dataset.pdpInit === "true") return;
    root.dataset.pdpInit = "true";

    var dataEl = root.querySelector("[data-pdp-variants]");
    if (!dataEl) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var serving = parseFloat(root.getAttribute("data-serving")) || 35;
    var threshold = parseFloat(root.getAttribute("data-threshold")) || 10;

    var priceEl = root.querySelector("[data-pdp-price]");
    var addPriceEl = root.querySelector("[data-pdp-add-price]");
    var addBtn = root.querySelector("[data-pdp-add]");
    var idInput = root.querySelector("[data-pdp-id]");
    var rindeTxt = root.querySelector("[data-pdp-rinde-txt]");
    var stockEl = root.querySelector("[data-pdp-stock]");
    var stockTxt = root.querySelector("[data-pdp-stock-txt]");
    var mainImg = root.querySelector("[data-pdp-main]");
    var groups = Array.prototype.slice.call(root.querySelectorAll("[data-pdp-optgroup]"));
    var litroEl = root.querySelector("[data-pdp-litro]");
    var litroTxt = root.querySelector("[data-pdp-litro-txt]");
    var litroMin = litroEl ? parseFloat(litroEl.getAttribute("data-min")) || 0 : 0;
    var litroBtn = null;

    function priceHtml(v) {
      if (v.cprice) {
        return '<span class="pdp__price-now pdp__price-now--sale">' + v.price + '</span>' +
          ' <s class="pdp__price-was">' + v.cprice + "</s>" +
          (v.off ? ' <span class="pdp__price-off">\u2212' + v.off + "%</span>" : "");
      }
      return '<span class="pdp__price-now">' + v.price + "</span>";
    }

    function rinde(title) {
      var m = String(title).toLowerCase().match(/([\d.]+)\s*(ml|l|lt|litro)/);
      if (!m) return "";
      var n = parseFloat(m[1]);
      var ml = /^l/.test(m[2]) ? n * 1000 : n;
      var s = Math.max(1, Math.round(ml / serving));
      return s === 1 ? "Rinde ~1 bebida" : "Rinde ~" + s + " bebidas";
    }

    function mlOf(title) {
      var m = String(title).toLowerCase().match(/([\d.]+)\s*(ml|l|lt|litro)/);
      if (!m) return 0;
      var n = parseFloat(m[1]);
      return /^l/.test(m[2]) ? n * 1000 : n;
    }

    function bebidas(ml) { return Math.max(1, Math.round(ml / serving)); }

    // Nota "en litro te ahorras $X en cada bebida". Solo con 260 ml (presentacion
    // chica, 100 a 500 ml) seleccionada y el litro disponible. Mismo calculo que "Rinde ~X".
    function litroNota(v) {
      if (!litroEl) return;
      litroEl.hidden = true;
      litroBtn = null;
      var ml = mlOf(v.title);
      if (ml < 100 || ml > 500) return;
      var litro = variants.filter(function (x) {
        if (x.id === v.id || mlOf(x.title) !== 1000 || !x.available) return false;
        for (var i = 0; i < x.options.length; i++) {
          if (x.options[i] !== v.options[i] && mlOf(x.options[i]) === 0) return false;
        }
        return true;
      })[0];
      if (!litro) return;
      var ahorro = Math.floor(v.cents / 100 / bebidas(ml) - litro.cents / 100 / bebidas(1000));
      if (ahorro < litroMin || ahorro < 1) return;
      groups.forEach(function (g, gi) {
        if (litro.options[gi] === v.options[gi]) return;
        g.querySelectorAll("[data-pdp-opt]").forEach(function (o) {
          if (o.getAttribute("data-value") === litro.options[gi]) litroBtn = o;
        });
      });
      if (!litroBtn) return;
      litroTxt.textContent = "en litro te ahorras $" + ahorro + " en cada bebida";
      litroEl.setAttribute("aria-label", "Cambiar a 1 L: te ahorras $" + ahorro + " en cada bebida");
      litroEl.hidden = false;
      litroFlecha();
    }

    // La flecha apunta al centro del boton de 1 L. Si la fila de tamanos se parte, sin flecha.
    function litroFlecha() {
      if (!litroEl || litroEl.hidden || !litroBtn) return;
      var row = litroBtn.parentNode;
      var first = row.querySelector("[data-pdp-opt]");
      if (!first || first.offsetTop !== litroBtn.offsetTop) {
        litroEl.classList.add("no-flecha");
        litroEl.style.removeProperty("--litro-w");
        litroEl.style.removeProperty("--litro-ax");
        return;
      }
      litroEl.classList.remove("no-flecha");
      var rowBox = row.getBoundingClientRect();
      var btnBox = litroBtn.getBoundingClientRect();
      var centro = btnBox.left - rowBox.left + btnBox.width / 2;
      litroEl.style.setProperty("--litro-w", Math.round(centro + 14) + "px");
      litroEl.style.setProperty("--litro-ax", Math.round(centro - 15) + "px");
    }

    if (litroEl) {
      litroEl.addEventListener("click", function () { if (litroBtn) litroBtn.click(); });
      window.addEventListener("resize", litroFlecha);
    }

    function currentSelection() {
      return groups.map(function (g) {
        var on = g.querySelector(".pdp__opt.is-active");
        return on ? on.getAttribute("data-value") : null;
      });
    }

    function findVariant(sel) {
      if (!groups.length) return variants[0];
      return variants.filter(function (v) {
        for (var i = 0; i < sel.length; i++) {
          if (sel[i] != null && v.options[i] !== sel[i]) return false;
        }
        return true;
      })[0];
    }

    function markSoldOut(sel) {
      groups.forEach(function (g, gi) {
        g.querySelectorAll(".pdp__opt").forEach(function (opt) {
          var test = sel.slice();
          test[gi] = opt.getAttribute("data-value");
          var v = findVariant(test);
          opt.classList.toggle("is-soldout", !!(v && !v.available));
        });
      });
    }

    function apply(v) {
      if (!v) return;
      if (priceEl) priceEl.innerHTML = priceHtml(v);
      if (idInput) idInput.value = v.id;
      if (rindeTxt) rindeTxt.textContent = rinde(v.title);
      litroNota(v);
      if (mainImg && mainImg.tagName === "IMG") {
        var matched = null;
        if (v.media_id != null) {
          matched = root.querySelector('[data-pdp-thumb][data-media-id="' + v.media_id + '"]');
        }
        if (matched) {
          root.querySelectorAll("[data-pdp-thumb]").forEach(function (x) { x.classList.remove("is-active"); });
          matched.classList.add("is-active");
          mainImg.removeAttribute("srcset");
          mainImg.src = matched.getAttribute("data-full");
        } else if (v.img) {
          mainImg.removeAttribute("srcset");
          mainImg.src = v.img.indexOf("?") > -1 ? v.img : v.img + "?width=1200";
        }
      }
      // batch / stock
      if (stockEl && stockTxt) {
        stockEl.classList.remove("is-ok", "is-low", "is-out");
        if (!v.available) {
          stockEl.classList.add("is-out");
          stockTxt.innerHTML = "Agotado, <b>siguiente batch: por definir</b>";
        } else if (v.managed && v.inventory > 0 && v.inventory <= threshold) {
          stockEl.classList.add("is-low");
          stockTxt.innerHTML = "<b>Por agotar</b>, quedan " + v.inventory + " de este batch";
        } else {
          stockEl.classList.add("is-ok");
          stockTxt.innerHTML = "Batch fresco, <b>disponible</b>";
        }
      }
      // add button
      if (addBtn) {
        if (!v.available) {
          addBtn.textContent = "Avísame cuando vuelva";
          addBtn.classList.add("is-out");
          addBtn.type = "button";
        } else {
          addBtn.classList.remove("is-out");
          addBtn.type = "submit";
          addBtn.innerHTML = 'Agregar · <span data-pdp-add-price>' + v.price + "</span>";
        }
      }
    }

    groups.forEach(function (g, gi) {
      g.querySelectorAll("[data-pdp-opt]").forEach(function (opt) {
        opt.addEventListener("click", function () {
          g.querySelectorAll(".pdp__opt").forEach(function (o) { o.classList.remove("is-active"); });
          opt.classList.add("is-active");
          var sel = currentSelection();
          markSoldOut(sel);
          apply(findVariant(sel));
        });
      });
    });

    // quantity
    var qty = root.querySelector("[data-pdp-qty]");
    var qminus = root.querySelector("[data-pdp-qminus]");
    var qplus = root.querySelector("[data-pdp-qplus]");
    function getQty() { var n = parseInt(qty.value, 10); return isNaN(n) || n < 1 ? 1 : n; }
    if (qminus) qminus.addEventListener("click", function () { qty.value = Math.max(1, getQty() - 1); });
    if (qplus) qplus.addEventListener("click", function () { qty.value = getQty() + 1; });

    // AJAX add to cart
    var addUrl = root.getAttribute("data-cart-add") || "/cart/add.js";
    var form = root.querySelector("form.pdp__form");
    if (form) {
      form.addEventListener("submit", function (e) {
        if (addBtn && addBtn.classList.contains("is-out")) { e.preventDefault(); return; }
        e.preventDefault();
        var id = idInput ? idInput.value : null;
        if (!id) return;
        var original = addBtn.innerHTML;
        addBtn.disabled = true;
        fetch(addUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: id, quantity: getQty() }] })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            addBtn.innerHTML = "Agregado ✓";
            document.dispatchEvent(new CustomEvent("cart:updated"));
            setTimeout(function () { addBtn.innerHTML = original; addBtn.disabled = false; }, 1600);
          })
          .catch(function () { addBtn.innerHTML = original; addBtn.disabled = false; });
      });
    }

    // thumbs
    root.querySelectorAll("[data-pdp-thumb]").forEach(function (t) {
      t.addEventListener("click", function () {
        root.querySelectorAll("[data-pdp-thumb]").forEach(function (x) { x.classList.remove("is-active"); });
        t.classList.add("is-active");
        if (mainImg && mainImg.tagName === "IMG") {
          mainImg.removeAttribute("srcset");
          mainImg.src = t.getAttribute("data-full");
        }
      });
    });

    // accordion
    root.querySelectorAll("[data-pdp-acc]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var panel = btn.parentNode.querySelector("[data-pdp-acc-panel]");
        var open = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", open ? "false" : "true");
        if (panel) panel.hidden = open;
      });
    });

    // initial state
    apply(findVariant(currentSelection()));
    markSoldOut(currentSelection());
  }

  function bootPdp(scope) {
    (scope || document).querySelectorAll("[data-pdp]").forEach(initPdp);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { bootPdp(document); });
  } else { bootPdp(document); }
  document.addEventListener("shopify:section:load", function (e) { bootPdp(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  function initReviews(root) {
    if (root.dataset.revsInit === "true") return;
    root.dataset.revsInit = "true";

    var pages = Array.prototype.slice.call(root.querySelectorAll("[data-revs-page]"));
    var dotsWrap = root.querySelector("[data-revs-dots]");
    if (pages.length <= 1) return;

    var i = 0;
    var timer = null;
    var autoplay = root.getAttribute("data-autoplay") === "true";
    var speed = parseFloat(root.getAttribute("data-speed")) || 6;

    var dots = pages.map(function (page, idx) {
      var b = document.createElement("button");
      b.className = "revs__dot" + (idx === 0 ? " is-active" : "");
      b.type = "button";
      b.setAttribute("aria-label", "Ver reseñas " + (idx + 1));
      b.addEventListener("click", function () {
        go(idx);
        restart();
      });
      if (dotsWrap) dotsWrap.appendChild(b);
      return b;
    });

    function go(next) {
      pages[i].classList.remove("is-active");
      if (dots[i]) dots[i].classList.remove("is-active");
      i = (next + pages.length) % pages.length;
      pages[i].classList.add("is-active");
      if (dots[i]) dots[i].classList.add("is-active");
    }
    function start() {
      if (!autoplay) return;
      timer = setInterval(function () {
        go(i + 1);
      }, speed * 1000);
    }
    function stop() {
      if (timer) clearInterval(timer);
    }
    function restart() {
      stop();
      start();
    }

    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);
    start();
  }

  function bootReviews(scope) {
    (scope || document).querySelectorAll("[data-reviews]").forEach(initReviews);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      bootReviews(document);
    });
  } else {
    bootReviews(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    bootReviews(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
